/**
 * Generic function to scroll an element to the top
 * @param selector - The CSS selector to find the scrollable element
 */
export default function scrollToTop(selector: string): void {
  const element = document.querySelector(selector);
  if (element) {
    element.scrollTop = 0;
  }
}
